import {
  TIME_ENTRIES_SUMMARY_DAILY_REQUEST,
  TIME_ENTRIES_SUMMARY_DAILY_SUCCESS,
  TIME_ENTRIES_SUMMARY_DAILY_FAILURE,
} from "./actionType";

// timeEntriesSummaryDailyRequest
export const timeEntriesSummaryDailyRequest = () => ({
  type: TIME_ENTRIES_SUMMARY_DAILY_REQUEST,
});
export const timeEntriesSummaryDailySuccess = (payload) => ({
  type: TIME_ENTRIES_SUMMARY_DAILY_SUCCESS,
  payload,
});
export const timeEntriesSummaryDailyFailure = (payload) => ({
  type: TIME_ENTRIES_SUMMARY_DAILY_FAILURE,
  payload,
});
